import Vision from "../../images/about-us/vision.png";
import Mission from "../../images/about-us/mission.png";

function AboutVision({ref, visible}) {
  return (
    <div className="about-us-vision" ref={ref}>
      <h1 className="large-vision">VISION</h1>
      <p className="large-mission">& MISSION</p>
      <div className={`vision ${visible ? "visible" : ""}`}>
        <div>
          <img src={Vision} alt="vision" />
          <h2>Vision</h2>
          <p>
            To be a first class Hub for enterprise solutions relied on by
            organizations in and around the world to drive their business
            processes.
          </p>
        </div>
      </div>
      <div className={`mission ${visible ? "visible" : ""}`}>
        <div>
          <img src={Mission} alt="mission" />
          <h2>Mission</h2>
          <p>
            To be a first class Hub for enterprise solutions relied on by
            organizations in and around the world to drive their business
            processes.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutVision;
